<template>
  <div>
    <modal-crear-editar
      :configuracion="configuracion_modal"
      @realizado="restablecer_inputs"
    ></modal-crear-editar>
    <tablita
      @cargar="cargar($event)"
      @ver_documento="ver_documento($event)"
      @cargar_url="cargar_url($event)"
      @nuevo="crear"
      @editar="editar($event)"
      @refresh="refrescar($event)"
      :configuracion="configuracion_tabla"
      :cols="columnas"
    ></tablita>
    <!-- <button class="btn btn-success" @click="calcular()">calcular</button> -->
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import ModalCrearEditar from "../../components/Modal/ModalEditarCrear";
import Tabla from "../../components/Tabla/Tabla";
//import lenguaje from '../../config/es_datatable.json'
export default {
  data: () => ({
    filter: "",
    columnas: [
      //{key:'id',label:'ID',busqueda:'',tipo:'string',searchable:true,path:'id'},
      {
        key: "fecha_ingreso",
        label: "Fecha Ingreso Portería",
        busqueda: "",
        tipo: "datetime",
        searchable: true,
        path: "fecha_ingreso",
      },
      {
        key: "ingreso_vehiculos_porteria_id",
        label: "N° Vuelta",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "ingreso_vehiculos_porteria_id",
      },
      {
        key: "patente",
        label: "Patente",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "patente",
      },
      {
        key: "numero_tickets",
        label: "Tickets",
        busqueda: "",
        tipo: "string",
        searchable: true,
        path: "numero_tickets",
      },
      {
        key: "motivo_ingreso",
        label: "Motivo Ingreso",
        busqueda: "",
        tipo: "string",
        searchable: false,
        path: "motivo_ingreso",
      },
      {
        key: "folios",
        label: "Folios Transbordador",
        busqueda: "",
        tipo: "html",
        searchable: false,
        path: "folios",
      },
      {
        key: "petroleo",
        label: "Carga Petroleo",
        busqueda: "",
        tipo: "html",
        searchable: false,
        path: "petroleo",
      },
      {
        key: "lavado",
        label: "Lavado",
        busqueda: "",
        tipo: "html",
        searchable: false,
        path: "lavado",
      },
      {
        key: "colacion",
        label: "Colación",
        busqueda: "",
        tipo: "html",
        searchable: false,
        path: "colacion",
      },
      /* {key:'tickets_id',label:'Ticket',busqueda:'',tipo:'select-loadable',ruta:'/tickets',parametro:'codigo_ticket',searchable:true,path:'ticket.codigo_ticket',opciones:[],valor_opcion:'id',label_opcion:'codigo_ticket'},
          {key:'empresas_id',label:'Empresa',busqueda:'',tipo:'select-loadable',ruta:'/empresas',parametro:'nombre',append_parametro:'&tipo_empresa_ids=4',searchable:true,path:'empresa_texto',opciones:[],valor_opcion:'id',label_opcion:'nombre'},
          {key:'dependencias_id',label:'Sucursal',busqueda:'',tipo:'select-loadable-dependiente',columna_dependiente:'empresas_id',ruta:'/dependencias',parametro:'nombre',searchable:true,path:'sucursal_texto',opciones:[],valor_opcion:'id',label_opcion:'nombre'},
          
          {key:'peso_informado',label:'Peso Informado',busqueda:'',tipo:'number',searchable:false,path:'peso_informado'},
          {key:'peso_real',label:'Peso Real',busqueda:'',tipo:'number',searchable:false,path:'peso_real'},
          {key:'restricciones_id',label:'Restricción',busqueda:'',tipo:'multiselect',searchable:true,path:'restricciones_texto',opciones:[],valor_opcion:'id',label_opcion:'nombre'},
          {key:'cantidad_bins',label:'Bins',busqueda:'',tipo:'number',searchable:false,path:'cantidad_bins'} */
    ],
    botones: [
      //{label:'Editar',clase:'btn-warning',evento:'editar',icono:'fa fa-pen'}
      //{label:'Ver Documento',clase:'btn-danger',evento:'ver_documento',icono:'fas fa-file'}
    ],
    lista: [],
    links: [],
    tickets: [],
    restricciones: [],
    inputs: [
      /* {cols:4,tipo:'numero',key:'codigo_ticket',valor:'',label:'N° Ticket (*)'},
          {cols:4,tipo:'select',key:'ciclo_ticket',valor:'',label:'Ciclo ticket (*)',opciones:[],valor_opcion:'id',label_opcion:'nombre'} */
    ],
    configuracion_modal: {
      titulo: "",
      ancho: "xl",
      ruta: "/vueltas_camiones",
      tipo_ruta: "post",
      titulo_boton: "Crear",
      clase_boton: "btn-success",
    },
    configuracion_tabla: {
      titulo: "Listado de Vueltas de Camiones",
      titulo_boton: "Crear Vuelta",
      clase_boton: "btn-primary",
      btn_nuevo: false,
    },
    pagina_actual: "",
    /* columns: [
            {label: 'Rut', field: 'rut'},
            {label: 'Nombre', field: 'nombre', headerClass: 'class-in-header second-class'}
        ], */
  }),
  mounted() {
    this.inicializar_tabla({
      columnas: [],
      lista: [],
      links: [],
      botones: [],
      botones_restringidos: [],
    });
    this.$emit("spinner", true);
    let storage = localStorage.getItem(this.path);
    if (storage) {
      storage = JSON.parse(storage);
      this.columnas.forEach((col) => {
        col.busqueda = storage.columnas.find((c) => c.key == col.key).val;
      });
    }
    //this.cargar_tickets();
    //this.cargar();
    this.$emit("cargar");
  },
  methods: {
    refrescar() {
      localStorage.removeItem(this.path);
      this.columnas.forEach((c) => {
        if (
          [
            "string",
            "number",
            "select",
            "select-loadable",
            "select-loadable-dependiente",
            "datetime",
            "html",
            "html_select",
          ].includes(c.tipo)
        ) {
          c.busqueda = "";
        }

        if (["multiselect"].includes(c.tipo)) {
          c.busqueda = [];
        }
      });
      this.$emit("cargar");
    },
    async calcular() {
      await this.axios
        .get(`${this.api}/reportes/viajes`, this.cabeceras_json)
        .then((res) => {})
        .catch((e) => {
          //console.log(e);
        });
      //this.cargar_restricciones();
    },

    async cargar_tickets() {
      await this.axios
        .get(`${this.api}/tickets?limit=9999999`, this.cabeceras_json)
        .then((res) => {
          this.tickets = res.data.data.data;
          this.$set(this.columnas[2], "opciones", this.tickets);
          //this.$set(this.inputs[2],'opciones',this.ciclos_ticket);
          //console.log('tickets',res.data.data);
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar_restricciones();
    },

    async cargar_restricciones() {
      await this.axios
        .get(`${this.api}/restricciones?limit=9999999`, this.cabeceras_json)
        .then((res) => {
          this.restricciones = res.data.data.data;
          this.$set(this.columnas[7], "opciones", this.restricciones);
          //this.$set(this.inputs[2],'opciones',this.ciclos_ticket);
        })
        .catch((e) => {
          //console.log(e);
        });
      this.cargar("");
    },

    async cargar($event = "") {
      //console.log('cargando',$event);
      this.$emit("spinner", true);
      this.pagina_actual = `${this.api}/vueltas_camiones${$event}`;
      this.lista = [];
      await this.axios
        .get(`${this.api}/vueltas_camiones${$event}`, this.cabeceras_json)
        .then((res) => {
          this.lista = res.data.data.data;
          this.links = res.data.data.links;
          /* let config = {
                  columnas:this.columnas,
                  lista:this.lista,
                  links:this.links
                } */
          this.inicializar_tabla({
            columnas: this.columnas,
            lista: this.lista,
            links: this.links,
            botones: this.botones,
          });
          this.$emit("refrescar_columnas");
          //this.$emit('generar',this.columnas,this.lista);
          ////console.log('listado',res.data.data.data);
          //$('#empresas').DataTable().draw();
        })
        .catch((e) => {
          //alert(e);
        });
      this.$emit("spinner", false);
    },
    async cargar_url(url) {
      if (url) {
        this.$emit("spinner", true);
        this.pagina_actual = url;
        await this.axios
          .get(url, this.cabeceras_json)
          .then((res) => {
            this.lista = res.data.data.data;
            this.links = res.data.data.links;
            ////console.log('listado',res.data.data.data);
            this.setear_lista({ lista: this.lista, links: this.links });
            //$('#empresas').DataTable().draw();
          })
          .catch((e) => {
            //alert(e);
          });
        this.$emit("spinner", false);
      }
    },
    crear() {
      this.setear_inputs(this.inputs);
      this.restablecer_inputs();
      this.configuracion_modal.ruta = `/guias`;
      this.configuracion_modal.tipo_ruta = "post";
      this.configuracion_modal.titulo_boton = "Crear";
      this.configuracion_modal.clase_boton = "btn-success";

      this.$emit("abrir", { inputs: this.inputs });
    },
    editar(evento) {
      //console.log('evento',evento);
      let item = evento.item;
      this.inputs.forEach((i) => {
        //recorrido del objeto a editar
        Object.keys(item).forEach((key) => {
          let valor = item[key];
          if (i.key == key) {
            i.valor = valor;
          }
        });
      });
      this.setear_inputs(this.inputs);
      this.configuracion_modal.ruta = `/guias/${evento.item.id}`;
      this.configuracion_modal.tipo_ruta = "put";
      this.configuracion_modal.titulo_boton = "Actualizar";
      this.configuracion_modal.clase_boton = "btn-warning";

      this.$emit("abrir");
    },
    restablecer_inputs() {
      this.cargar_url(this.pagina_actual);
      this.inputs.forEach((i) => {
        i.valor = "";
      });
      this.setear_inputs(this.inputs);
    },

    ver_documento(event) {
      window.open(`${event.item.url}`, "_blank");
    },
    ...mapActions(["inicializar_tabla", "setear_lista", "setear_inputs"]),
  },
  components: {
    "modal-crear-editar": ModalCrearEditar,
    tablita: Tabla,
  },
  computed: {
    ...mapState(["api", "api_public", "cabeceras_json"]),
    query() {
      let string = "?";
      let and = "";
      let total = this.columnas.length - 1;
      this.columnas.forEach((c, index) => {
        if (index > 0 && string.length > 0) {
          and = "&";
        } else if (index == total) {
          and = "";
        }

        if (c.busqueda != "") {
          string += `${and}${c.key}=${c.busqueda}`;
        }
      });
      return string;
    },
    path() {
      return this.$router.currentRoute.path;
    },
  },
};
</script>
<style>
.form-control {
  height: calc(1em + 1.25rem + 5px);
}
</style>